import email from "./email.png";
import phone from "./phone.png";
import school from "./school.png";
const images = {
    email,
    phone,
    school
}
export default images;
